/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react"
import "./src/assets/scss/global.scss"
import resourcesCategories from "./src/constants/resourcesCategories"
import { wrapRootElement as wrapStatsig } from "./src/components/StatsigProviderWrapper"
import { ConsentGateProvider } from "./src/components/consent"

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === "undefined") {
    await import("intersection-observer")
  }
}

let oldPathname = ""

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const { pathname } = location
  if (Object.values(resourcesCategories).some((route) => route.url === pathname || route.url + "/" === pathname) && oldPathname.indexOf(resourcesCategories.all.url) !== -1) {
    oldPathname = pathname
    return false
  }
  oldPathname = pathname
  window.scrollTo(0, 0)
}

// Root wrapping order (outside -> in):
//   ConsentGateProvider    - mounts ConsentBanner + ConsentLoader; exposes consent state
//   StatsigProviderWrapper - reads consent via context, only initializes after opt-in
//   <page>
export const wrapRootElement = ({ element }) => {
  const withStatsig = wrapStatsig({ element })
  return <ConsentGateProvider>{withStatsig}</ConsentGateProvider>
}

// Log Activeloop branding and hiring message
console.log(`
        @@@@@@@@@@@@@@@
     @@@@@@@@@@@@@@@@@@@@@
   @@@@@@@@           ########
  @@@@@@@               #######
 @@@@@@@                 #######
 @@@@@@                   #######
 @@@@@@                   #######
 @@@@@@                   #######
 @@@@@@@                 #######
  @@@@@@@               #######
   @@@@@@@@           ########
     @@@@@@@@@@@@@@@@@@@@@
        @@@@@@@@@@@@@@@
We're hiring at Activeloop!
https://careers.activeloop.ai/
`)
